import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    width={size}
    height={size}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <path
      d="M7.16789 2H17.4987l3.6364 20H3.53153L7.16789 2ZM12.3333 4v4M12.3333 10v4M12.3333 16v4"
      stroke={color}
      strokeWidth="2"
    />
  </svg>
);
